import clsx from "clsx";
import styles from "./style.module.scss";

export default function QueryPostedItemSkeleton() {
  return (
    <li className={clsx(styles.truckItem, "rounded-b-base animate-pulse")}>
      <div className={styles.cardHeader}>
        <div className="flex items-center gap-2">
          <span className="h-5 w-24 bg-gray-300 rounded" />
          <span className="h-4 w-4 bg-gray-300 rounded" />
          <span className="h-5 w-24 bg-gray-300 rounded" />
        </div>
        <span className="h-4 w-32 bg-gray-300 rounded" />
      </div>
      <ul className={styles.cardContent}>
        {[...Array(6)].map((_, index) => (
          <li key={index}>
            <span className="h-3 w-16 bg-gray-300 rounded block mb-1" />
            <span className="h-4 w-20 bg-gray-300 rounded block" />
          </li>
        ))}
      </ul>
      <div className={styles.cardFooter}>
        <div className="flex gap-2">
          <span className="h-10 w-10 bg-gray-300 rounded-full" />
          <span className="h-10 w-10 bg-gray-300 rounded-full" />
          <span className="h-10 w-10 bg-gray-300 rounded-full" />
        </div>
        <div className="flex gap-2">
          <span className="h-8 w-20 bg-gray-300 rounded-full" />
          <span className="h-8 w-16 bg-gray-300 rounded-full" />
        </div>
      </div>
    </li>
  );
}
